export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/mapbox-gl-csp-worker.8d532bf5.worker.js");
}
